import React, { useState } from 'react';
import TableMui from './TableMui';
import moment from 'moment-timezone';
import LambdaFetch from '../functions/FetchFromLambda';
import getTableOptions from '../constants/TableOptions';
import DialogTable from './DialogTable';
import {
  invoiceCols,
  invoiceWithVendorCols,
  invoiceDistCols,
  invoicePaymentCols,
  activityCols,
  invoiceAttachmentsCols
  // invoiceReactTableCols
} from '../constants/VendorCols';
import PoDetailDialog from './PoDetailDialog';
import { dateFormat } from '../utils/formatter';
import { ServerSideTable } from './ServerSideTable';
import ReactTableServerSide from '../components/ReactTableServerSide';
import { useInvoiceReactTableCols } from '../hooks/VendorCols';
import { DashboardAthenaTableServerSide } from '../components/DashboardAthenaTableServerSide'
import fetchFromAthena from '../functions/FetchFromAthena'
import { DashboardAthenaTable } from '../components/DashboardAthenaTable'
import LoadingLink from './LoadingLink'
import DocumentList from './DocumentList';
import { resolveEnabledModules, isModuleEnabled } from '../config/permissions-registry';
import CommentDialog from './CommentDialog';

export function VendorInvoicesServerSide(props) {
  const [objInfo, setObjInfo] = useState(null);
  const [payment, setPayment] = useState(null);
  const [attachments, setAttachments] = useState(null);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [activityInfo, setActivityInfo] = useState(null);

  // Get clientModules from credentials to check module access
  const rawModules = props?.fetchInitialData?.credentials?.clientModules;
  const clientModules = rawModules ? resolveEnabledModules(rawModules) : null;
  const isDocumentsModuleEnabled = clientModules ? isModuleEnabled('DOCUMENTS', clientModules) : true; // Default to true for backward compatibility
  const invoiceReactTableCols = useInvoiceReactTableCols(rawModules);

  const handleClose = () => {
    setObjInfo(null);
    setPayment(null);
    setSelectedInvoice(null);
    setActivityInfo(null);
  };
  const [poData, setpoData] = useState({
    poHeaderData: null,
    poDetailData: null,
    poReceive: null,
    poReleases: null,
    open: false,
  });
  const getDistribData = async (objId) => {
    try {

      const data = await fetchFromAthena({
        queryName: 'invoice_dist_read',
        headers: {
          objId,
        },
        accessToken: props.credentials.user.accessToken,
        credentials: props.credentials
      })

      setObjInfo(
        data.map((item) => {
          return [
            item.DIST_SEQ_NBR,
            item.DISTRIB_DATE,
            item.DESCRIPTION,
            item.DIST_COMPANY || '',
            item.DIS_ACCT_UNIT,
            `${item.DIS_ACCOUNT}${item.DIS_SUB_ACCT ? `-${item.DIS_SUB_ACCT}` : ''
            }`,
            item.ACTIVITY ? (
              <div
                className="editLink"
                onClick={() => {
                  const win = window.open(
                    `/actrans?id=${item.ATN_OBJ_ID}&type=OBJ_ID`,
                    '_blank'
                  );
                  win.focus();
                }}
              >
                {item.ACTIVITY}
              </div>
            ) : (
              ''
            ),
            item.UNT_AMOUNT || '',
            parseFloat(item.ORIG_BASE_AMT) || 0,
          ];
        })
      );
    } catch (e) {
      console.log(e);
    }
  }

  const updateRelease = (poNum, company, code, release) => {
    getPo(poNum, company, code, release)
  }

  const getPo = async (id, company, code, release) => {
    try {
      if (!id || !company) return null
      setpoData({ ...poData, open: true })
      const resp = await LambdaFetch(
        'po',
        'post',
        props.credentials.user.accessToken,
        JSON.stringify({
          action: 'get-po',
          company: company,
          po: id,
          code: code,
          release: release
        }),
        '',
        props.credentials,
        '',
        'No Po Found'
      )
      if (!resp) throw new Error('No Po')
      setpoData({
        ...poData,
        poHeaderData: resp.data.poHeader[0],
        poDetailData: resp.data.poDetail,
        poReceive: resp.data.poReceive,
        poReleases: resp.data.poReleases,
        open: true,
      });
    } catch (e) {
      console.log(e);
    }
  };
  const getAttachment = async (index) => {
    const data = await fetchFromAthena({
        queryName: 'ap_invoice_attachments_read',
        headers: {
          prm_l_index: index
        },
        accessToken: props.credentials.user.accessToken,
        credentials: props.credentials
      })
      const attachData = data.map((d) => {
        return {
          ...d,
          LINK: <a className='editLink' href={d.comment_text} target='_blank'>{d.comment_text}</a>
        }
      })
      setAttachments(attachData)
  }
  const getPaymentData = async (inv, comp) => {
    try {

      const data = await fetchFromAthena({
        queryName: 'ap_payment_read',
        headers: {
          vendor: props.vendor,
          invoice: inv.trim(),
          company: comp,
        },
        accessToken: props.credentials.user.accessToken,
        credentials: props.credentials
      })
      
      // const resp = await LambdaFetch(
      //   'vendors',
      //   'post',
      //   props.accessToken,
      //   JSON.stringify({
      //     action: 'invoice-payment-read',
      //     vendor: props.vendor,
      //     invoice: inv.trim(),
      //     company: comp,
      //   }),
      //   null,
      //   props.credentials
      // );
      const payments = data.map((p) => {
        p['STATUS'] = `${p.REC_STATUS_DESC} (${p.REC_STATUS})`;
        p['PAYMENT_CODE'] = `${p.BANK_INST_DESC} (${p.BANK_INST_CODE})`;
        return p;
      });
      setPayment(payments);
      // if (resp.success) {
      //   setPayment(payments);
      // } else {
      //   setObjInfo(null);
      // }
    } catch (e) {
      console.log(e);
    }
  };

  if (!props.vendor || !props.selectedGroup) return null;

  const options = getTableOptions({
    cols: invoiceCols,
    fileName: props.fileName,
  });

  const tableDataTransformation = (rows) => {
    return rows.map((row) => {
      return {
        ...row,
        INVOICE: row.INVOICE ? (
          <div
            className='editLink'
            onClick={() => {
              const suffix = row.SUFFIX || '0'
              const url = `/invoice-matching?company=${encodeURIComponent(row.COMPANY)}&vendor=${encodeURIComponent(props.vendor)}&invoice=${encodeURIComponent(row.INVOICE)}&suffix=${encodeURIComponent(suffix)}`
              const win = window.open(url, '_blank')
              win.focus()
            }}
            style={{ cursor: 'pointer' }}
          >
            {row.INVOICE}
          </div>
        ) : (
          ''
        ),
        PO_LINK: row.PO_NUMBER ? (
          row.PO_TYPE === 'agmt' && row.PROCURE_GROUP && row.AGMT_TYPE && row.VEN_AGRMT_REF ? (
            <div
              className='editLink'
              onClick={() => {
                const win = window.open(
                  `/vendor-agreement?procureGroup=${encodeURIComponent(row.PROCURE_GROUP)}&agreementType=${encodeURIComponent(row.AGMT_TYPE)}&agreementRef=${encodeURIComponent(row.VEN_AGRMT_REF)}`,
                  '_blank'
                )
                win.focus()
              }}
            >
              {row.PO_NUMBER}
            </div>
          ) : row.PO_TYPE === 'po' && row.COMPANY ? (
            <div
              className='editLink'
              onClick={() => {
                const win = window.open(
                  `/po?company=${row.COMPANY}&po=${row.PO_NUMBER}&pocode=${row.PO_CODE}`,
                  '_blank'
                )
                win.focus()
              }}
            >
              {row.PO_NUMBER}
            </div>
          ) : (
            <div>{row.PO_NUMBER}</div>
          )
        ) : (
          ''
        ),
        DISTRIBUTION: (
          <LoadingLink
            onClick={async () => {
              await getDistribData(row.OBJ_ID);
              setSelectedInvoice(row.INVOICE);
            }}
          >
            view
          </LoadingLink>
        ),
        PAYMENT: (
          <LoadingLink
            onClick={async () => {
              await getPaymentData(row.INVOICE, row.COMPANY);
              setSelectedInvoice(row.INVOICE);
            }}
          >
            view
          </LoadingLink>
        ),
        ATTACHMENT_VIEW: row.HAS_ATTACHMENTS === '1'  ? (
           <LoadingLink
            className='editLink'
            onClick={async() => {
              setSelectedInvoice(row.INVOICE);
              await getAttachment(row.L_INDEX);
            }}
          >
            view
           </LoadingLink>
        ) : (
          ''
        ),
        COMMENT_VIEW: row.COMMENT_INDEX ? (
          <CommentDialog
          {...props}
          text="view"
            fileName={row.COMMENT_FILENAME}
            index={row.COMMENT_INDEX}
          />
        ) : (
          ''
        ),
        // Only add DOCUMENTS property if the DOCUMENTS module is enabled
        ...(isDocumentsModuleEnabled ? {
          DOCUMENTS: (
            <DocumentList 
              path={`invoices/${row.COMPANY}/${props.vendor.trim()}/${row.INVOICE}`}
              credentials={props?.fetchInitialData?.credentials}
              linkText="view"
              title="Invoice Documents"
              baseFolderLabel=""
            />
          )
        } : {})
      };
    });
  };
  const invCols = props.showVendor ? invoiceWithVendorCols : invoiceCols;

  return (
    <>
      <PoDetailDialog
        {...props}
        poHeaderData={poData.poHeaderData}
        poDetailData={poData.poDetailData}
        poReceive={poData.poReceive}
        poReleases={poData.poReleases}
        updateRelease={updateRelease}
        open={poData.open}
        close={() =>
          setpoData({
            ...poData,
            poHeaderData: null,
            poDetailData: null,
            poReceive: null,
            poReleases: null,
            open: false,
          })
        }
      />

      <DialogTable
        tableTitle={selectedInvoice}
        isOpen={!!attachments}
        handleClose={() => setAttachments(null)}
        tableData={attachments}
        cols={invoiceAttachmentsCols}
        fileName={`${props.fileName}_Attachments_${selectedInvoice}`}
        simpleTable={true}
      />

      <DialogTable
        tableTitle={selectedInvoice}
        isOpen={!!payment}
        handleClose={handleClose}
        tableData={payment}
        cols={invoicePaymentCols}
        fileName={`${props.fileName}_Payments_${selectedInvoice}`}
        noFooter
      />

      <DialogTable
        tableTitle={selectedInvoice}
        isOpen={!!objInfo}
        handleClose={handleClose}
        tableData={objInfo}
        cols={invoiceDistCols}
        totalColIndex={8}
        fileName={`${props.fileName}_Distribution_${selectedInvoice}`}
      />
      <DialogTable
        isOpen={!!activityInfo}
        handleClose={() => setActivityInfo(null)}
        tableData={activityInfo}
        cols={activityCols}
        simpleTable={true}
      />

      <div style={{ marginTop: '1rem ' }}>



        <DashboardAthenaTable
          {...props}
          isTempTable={true}
          params={{ vendor: props.vendor, vendorGroup: props.selectedGroup }}
          tableColumns={invoiceReactTableCols}
          reportParamName="ap_invoice_read_serverside_v2"
          reportName='ap_invoice_read_serverside_v2_temp'
          tableTitle={''}
          transform={tableDataTransformation}
          callback={() => { }}
          downloadFileName={'Ap_Invoice_Download'}
        />
      </div>
    </>
  );
}
